import { render } from "./Home.vue?vue&type=template&id=501c4858&scoped=true&ts=true&lang=pug"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=501c4858&scoped=true&lang=css"

import exportComponent from "E:\\UiDesk\\laragon-5.0.0\\www\\click-to-call\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501c4858"]])

export default __exports__